import React from "react";
import { Card, Col, Container, Row } from "reactstrap";
import Header from "components/Headers/Header";
import threeways from "../../assets/img/custom/threeways.png";
import coach from "../../assets/img/custom/coach.png";
import post from "../../assets/img/custom/post.jpg";
import team from "../../assets/img/custom/team.jpg";

const styles = {
  image: { maxHeight: "60px" },
  title: { fontSize: "20px", color: "black", fontWeight: "bold" },
  number: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "black",
    paddingLeft: "10px",
  },
  headerTitle: { fontSize: "41px", color: "black" },
  threeWaysImg: { maxHeight: "200px" },
};

const ImproveChanceToSellLicenses = () => {
  return (
    <>
      <Header />
      <Container fluid>
        <Card className="p-3">
          <Row className="align-items-center">
            <Col md={3} className="d-flex">
              <img
                src={threeways}
                alt="Under construction"
                className="img-fluid"
                style={styles.threeWaysImg}
              />
            </Col>
            <Col md={9}>
              <h1 style={styles.headerTitle}>
                Three ways to improve your chances to sell to fans here
              </h1>
            </Col>
          </Row>

          <Row className="mt-4 ml-2 align-items-center">
            <Col md={3} lg={2} className="d-flex justify-content-center">
              <img
                src={coach}
                alt="Under construction"
                className="img-fluid"
                style={styles.image}
              />
            </Col>
            <Col md={9} lg={10}>
              <h1 style={styles.title}>
                1. Ask your Family and Friends to register here as Fans, because
                then they can view your profile and advise you.
              </h1>
            </Col>
          </Row>

          <Row className="ml-2 mt-3 align-items-center">
            <Col md={3} lg={2} className="d-flex justify-content-center">
              <img
                src={team}
                alt="Under construction"
                className="img-fluid"
                style={styles.image}
              />
            </Col>
            <Col md={9} lg={10}>
              <h1 style={styles.title}>
                2. Ask Athletes you know to register here, because they can benefit
                from knowing FHP FANS.
              </h1>
            </Col>
          </Row>

          <Row className="ml-2 mt-3 align-items-center">
            <Col md={3} lg={2} className="d-flex justify-content-center">
              <img
                src={post}
                alt="Under construction"
                className="img-fluid"
                style={styles.image}
              />
            </Col>
            <Col md={9} lg={10}>
              <h1 style={styles.title}>
                3. Link your posts on SOCIAL MEDIA about your sports experience to
                your PROFILE here, so FANS can get to know you.
              </h1>
            </Col>
          </Row>
        </Card>
      </Container>
    </>
  );
};

export default ImproveChanceToSellLicenses;
